import MobileDetect from "mobile-detect";

export const isMobile = (): string | null => {
  const md = new MobileDetect(window.navigator.userAgent);

  return md.mobile();
};

export const isIPhone = (): boolean => {
  const md = new MobileDetect(window.navigator.userAgent);

  return md.is("iPhone");
};

export const isIPad = (): boolean => {
  const md = new MobileDetect(window.navigator.userAgent);

  return md.is("iPad");
};
